import React from 'react';

const spinnerKeyframes = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

// Inject CSS if not already present
if (!document.querySelector('#spinner-keyframes')) {
  const style = document.createElement('style');
  style.id = 'spinner-keyframes';
  style.textContent = spinnerKeyframes;
  document.head.appendChild(style);
}

const StoreItems = ({ items = [], selectedItem, setSelectedItem, setShowRemoveModal, setItemToRemove, setShowUploadPopup, setEditItem, uploadingItems = [] }) => (
  <div style={{ width: '250px' }}>
    <h3 style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '10px' }}>
      Store Items
    </h3>
    {items.length === 0 && uploadingItems.length === 0 ? (
      <p style={{ color: '#666', fontSize: '14px' }}>
        No items in this store yet.
      </p>
    ) : (
      <ul
        style={{
          listStyle: 'none',
          padding: '0',
          maxHeight: '384px', // 6 items * (40px height + 8px margin + 8px padding + 8px border)
          overflowY: 'auto', // Enable vertical scrolling
        }}
      >
        {uploadingItems.filter(uploadItem =>
          !items.some(item => item.itemName === uploadItem.itemName)
        ).map((uploadItem) => (
          <li
            key={`uploading-${uploadItem.id}`}
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '8px 12px',
              backgroundColor: '#FFF3CD',
              border: '2px solid #FFC107',
              borderRadius: '8px',
              marginBottom: '8px',
            }}
          >
            <div
              style={{
                width: '40px',
                height: '40px',
                borderRadius: '4px',
                backgroundColor: '#FFC107',
                marginRight: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '12px',
                fontWeight: 'bold',
                color: '#856404',
              }}
            >
              {uploadItem.progress}%
            </div>
            <span
              style={{
                flex: '1',
                fontSize: '14px',
                color: '#856404',
                textAlign: 'left',
                marginRight: 'auto',
              }}
            >
              {uploadItem.itemName}
            </span>
            <div
              style={{
                width: '16px',
                height: '16px',
                border: '2px solid #856404',
                borderTop: '2px solid transparent',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
              }}
            />
          </li>
        ))}
        {items.map((item) => (
          <li
            key={item.id}
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '8px 12px',
              backgroundColor: '#F5F5F5',
              border: selectedItem?.id === item.id ? '2px solid #4A90E2' : '2px solid transparent',
              borderRadius: '8px',
              marginBottom: '8px',
            }}
          >
            {item.imageUrl ? (
              <img
                src={item.imageUrl}
                alt={item.itemName}
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '4px',
                  objectFit: 'cover',
                  marginRight: '8px',
                  cursor: 'pointer',
                }}
                onClick={() => setSelectedItem(item)}
              />
            ) : (
              <div style={{ width: '40px', height: '40px', marginRight: '8px' }} />
            )}
            <span
              onClick={() => setSelectedItem(item)}
              style={{
                flex: '1',
                fontSize: '14px',
                color: '#2D3E50',
                cursor: 'pointer',
                textAlign: 'left',
                marginRight: 'auto',
              }}
            >
              {item.itemName}
            </span>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <button
                onClick={() => {
                  setEditItem(item);
                  setShowUploadPopup(true);
                }}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#000',
                  cursor: 'pointer',
                  fontSize: '16px',
                  padding: '0',
                }}
              >
                <span className="material-icons" style={{ fontSize: '16px' }}>edit</span>
              </button>
              <button
                onClick={() => {
                  setShowRemoveModal(true);
                  setItemToRemove({ id: item.id, name: item.itemName });
                }}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#000',
                  cursor: 'pointer',
                  fontSize: '16px',
                  padding: '0',
                }}
              >
                ✕
              </button>
            </div>
          </li>
        ))}
      </ul>
    )}
  </div>
);

export default StoreItems;